export default __webpack_public_path__ + "static/media/icon-long-arrow-alt-down-solid.39b277e8.svg";